import { MatDialog } from '@angular/material/dialog';
import { ApplicationRef, Injector } from "@angular/core";
import { MediaMatcher } from '@angular/cdk/layout';
import { Router } from '@angular/router';

export const services: { [key: string]: { provide: any, deps: any[], useClass?: any } } = {
  'MatDialog': {
    provide: MatDialog,
    deps: []
  }
}

export class ServiceLocator {
  static injector: Injector;
  static dialog: MatDialog;
  static media: MediaMatcher;
  static router: Router;
  static changeDetectorRef: ApplicationRef;
}
